/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../redux/reducers/reducer'

import PillarLegs from '../../PillarLegs';
import RightPorchLeg from '../../PillarLegs/RightPorchLeg';
import LeftPorchLeg from '../../PillarLegs/LeftPorchLeg';


const Legs = ({ overlapTrussArr, normalMap, envMap, setLeanToTrussPosArr }) => {

    const [isEqualRightHeight, setIsEqualRightHeight] = useState(false);
    const [leftPorchLength, setLeftPorchLength] = useState(0);
    const [leanToLength, setLeanToLength] = useState(0)
    
    const trimThickness = 0.2;

    const roofPitchHeight = (params.b_l_t_r_pR / 12) * params.leanR_p_w;
    const trimOffsetHeight = (params.p_r_p / 12) * trimThickness;

    const angle = useMemo(() => {
        const a =Math.atan((roofPitchHeight - (isEqualRightHeight && trimOffsetHeight)) / (params.leanR_p_w - (isEqualRightHeight && trimThickness)));
        return a;
    }, [isEqualRightHeight, params.leanR_p_w, roofPitchHeight, trimOffsetHeight]) 

    const angleOffset = useMemo(() => {
        return (Math.atan(params.b_l_t_r_pR / 12) - angle);
    }, [params.b_l_t_r_pR, angle]) 

    const leanRRoofLeftHeight = useMemo(() => {
        return (params.b_l_t_r_pR / 12) * params.leanR_p_w;
    }, [params.b_l_t_r_pR, params.leanR_p_w])

    useMemo(() => {
        if(params.p_h === leanRRoofLeftHeight + params.leanR_p_h) setIsEqualRightHeight(true)
        else setIsEqualRightHeight(false)

    }, [params.p_h, params.leanR_p_h, leanRRoofLeftHeight, params.b_l_t_r_pR, params.leanR_p_w]) 


    return (
        <>
        {(const_var.DistanceArr!=undefined && const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) && 
            <group rotation={[0, Math.PI / 2, 0]}>
                <PillarLegs leanToKey={'right'} setLeanToTrussPosArr={setLeanToTrussPosArr} normalMap={normalMap} envMap={envMap} overlapTrussArr={overlapTrussArr} leftPorchLength={leftPorchLength} setLeanToLength={setLeanToLength} />
                {params.add_right_back_lean_porch && <RightPorchLeg leanToKey={'right'} isAction={isEqualRightHeight} angle={angle} trimOffsetHeight={trimOffsetHeight} angleOffset={angleOffset} overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} leanToLength={leanToLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap}/>}
                {params.add_right_front_lean_porch && <LeftPorchLeg leanToKey={'right'} isAction={isEqualRightHeight} angle={angle} trimOffsetHeight={trimOffsetHeight} angleOffset={angleOffset} overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} setLeftPorchLength={setLeftPorchLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap} />}
            </group>
        }
        </>
    )
}

export default Legs
